import { type Control, Controller, type ControllerProps, type FieldPath, type FieldValues } from 'react-hook-form';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';

type CProps = Omit<ControllerProps<FieldValues, FieldPath<FieldValues>, FieldValues>, 'render'>;

interface FormTextProps extends CProps {
  control: Control<any>;
  label: React.ReactNode;
}

export const FormCheckbox: React.FC<FormTextProps> = ({ label, ...rest }) => {
  return (
    <Controller
      {...rest}
      render={({ field: { ref, value, onChange, onBlur, name }, fieldState: { error } }) => (
        <FormControl error={!!error}>
          <FormControlLabel
            label={label}
            control={
              <Checkbox
                name={name}
                checked={Boolean(value)}
                onChange={(_, checked) => onChange(checked)}
                onBlur={onBlur}
                slotProps={{ input: { ref } }}
              />
            }
          />
          {error?.message && <FormHelperText role="alert">{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
